import React from 'react';
import PropTypes from 'prop-types';

function MirIcon({ className, monochrome }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="71"
      height="36"
      viewBox="0 0 71 36"
      className={className}
    >
      <defs>
        <linearGradient id="MirLogoIcon_a" x1="-.2%" y1="50%" y2="50%">
          <stop offset="0%" stopColor="#00B4E6" />
          <stop offset="100%" stopColor="#088CCB" />
        </linearGradient>
      </defs>
      <g fill="none" fillRule="evenodd">
        <path
          fill={monochrome ? '#888' : 'url(#MirLogoIcon_a)'}
          d="M49.2 0H38.7c.5 3.5 4 6.8 7.6 6.8h8.4l.1-1.2c0-3.1-2.5-5.6-5.6-5.6z"
          transform="translate(8 9.6)"
        />
        <path
          fill={monochrome ? '#000' : '#4DB45F'}
          d="M47.6 17v8.4h5V21h4.6c2.5 0 4.6-1.7 5.3-4h-15zM29.5 9.5v15.8H34s1.1 0 1.7-1.1l4-8h.5v9.1h5.1V9.6h-4.5s-1.1.1-1.7 1.1l-4 8h-.5V9.5h-5.1zM8 25.4V9.6h5s1.6 0 2.3 2.3l2.3 6.7L20 12c.8-2.3 2.2-2.3 2.2-2.3h5.1v15.8h-5V17h-.6l-2.9 8.5h-2.2L13.7 17H13v8.5H8z"
        />
      </g>
    </svg>
  );
}

MirIcon.propTypes = {
  className: PropTypes.string,
  monochrome: PropTypes.bool,
};

export default MirIcon;
